export default __webpack_public_path__ + "static/media/image-on.a7cebb21.svg";